/**
 * Rotas do módulo Central do Parceiro (E21.1.1 + E21.1.4).
 *
 * - `/central` → gestão operador↔setor (gate `central:manage_operators`).
 * - `/central/gestao` → composer + gestão de posts (gate `central:publish`, E21.1.4).
 */
import { lazy } from "react";

import { ModuleRoutes } from "../types";

const CentralOperatorsPage = lazy(() => import("@/pages/central/CentralOperatorsPage"));
const CentralGestaoPage = lazy(() => import("@/pages/central/CentralGestaoPage"));
const CentralDocumentsPage = lazy(
  () => import("@/pages/central/CentralDocumentsPage")
);
const CentralArticlesPage = lazy(
  () => import("@/pages/central/CentralArticlesPage")
);
const CentralOversightPage = lazy(
  () => import("@/pages/central/CentralOversightPage")
);
const CentralTemplatesPage = lazy(
  () => import("@/pages/central/CentralTemplatesPage")
);
const CentralRemessaPage = lazy(
  () => import("@/pages/central/CentralRemessaPage")
);

export const centralRoutes: ModuleRoutes = {
  moduleId: "central",
  basePath: "/central",
  routes: [
    {
      path: "/central",
      element: <CentralOperatorsPage />,
      permission: { resource: "central", action: "manage_operators" },
    },
    {
      path: "/central/gestao",
      element: <CentralGestaoPage />,
      permission: { resource: "central", action: "publish" },
    },
    {
      // E21.3.2 (G3) — Biblioteca de Documentos (gestão do operador)
      path: "/central/documentos",
      element: <CentralDocumentsPage />,
      permission: { resource: "central", action: "publish" },
    },
    {
      // E21.2.2 (G2) — Base de Conhecimento (gestão do operador)
      path: "/central/artigos",
      element: <CentralArticlesPage />,
      permission: { resource: "central", action: "publish" },
    },
    {
      // E21.6.2 (G6) — Painel de Controle (oversight). Gate publish (operador vê
      // seus setores; quem tem central:oversee vê todos — resolvido no backend).
      path: "/central/painel",
      element: <CentralOversightPage />,
      permission: { resource: "central", action: "publish" },
    },
    {
      // E21.4.3 (G4) — Templates de Remessa (gestão do operador)
      path: "/central/templates",
      element: <CentralTemplatesPage />,
      permission: { resource: "central", action: "publish" },
    },
    {
      // E21.4.4 (G4) — Gerar Remessa (gera + baixa o PDF)
      path: "/central/remessas",
      element: <CentralRemessaPage />,
      permission: { resource: "central", action: "publish" },
    },
  ],
};
